module.exports = "../../../../platform/assets/pageMainIcon/simple_danjuweihulei2.svg";